import React from 'react';
import { Outlet } from 'react-router-dom';
import { initiateAdminLogin } from './authentication';

async function login() {
  await initiateAdminLogin();
}

export default function AdminRoute({
  isAdminAuthenticated,
}: any) {
  if (!isAdminAuthenticated) {
    login();
    return null;
  }

  return <Outlet />;
}